module.exports = __webpack_public_path__ + "img/speeding.d81c3f4a.svg";